// import {initCounter} from '../plugins/counter';

$(function () {
    let customPlotLines = [];
    let chart22Width = $('#chart-2-2').width();
    let resizedFinished;
    let animated = 0;

    $(window).on('resize', function() {
        clearTimeout(resizedFinished);
        resizedFinished = setTimeout(function(){
            chart22Width = $('.section-2-2 .chart-container').width();
            if(window['chart22'].setSize()){
                window['chart22'].setSize(chart22Width, chart22Width);
            }
        }, 250);
    });

    function drawPlotLines(chart) {
        if (customPlotLines.length) {
            customPlotLines.forEach(function (customPlotLine) {
                customPlotLine.destroy();
            })
        }

        let center = [];
        let radius = [];

        center[0] = chart.pane[0].center[0];
        center[1] = chart.pane[0].center[1];
        let pieRadius = chart.pane[0].center[2];

        radius[0] = pieRadius * (0.75 + ((1 - 0.75) / 2)) / 2 ;
        radius[1] = pieRadius * (0.4 + ((0.65 - 0.4) / 2)) / 2;

        customPlotLines[0] = chart.renderer.circle(center[0], center[1], radius[0]).attr({
            fill              : 'transparent',
            stroke            : 'rgba(113, 113, 113, 0.6)',
            'stroke-width'    : 2,
            'stroke-dasharray': '8, 8',
            zIndex            : 2
        }).add();

        customPlotLines[1] = chart.renderer.circle(center[0], center[1], radius[1]).attr({
            fill              : 'transparent',
            stroke            : 'rgba(113, 113, 113, 0.6)',
            'stroke-width'    : 2,
            'stroke-dasharray': '8, 8',
            zIndex            : 2
        }).add();
    }

    let series = [{
        name: 'Indonesia',
        data: [{
            color      : '#f16521',
            radius     : '100%',
            innerRadius: '77%',
            y: 64.9
        }]
    }, {
        name: 'Rata-rata dunia',
        data: [{
            color      : '#FFA235',
            radius     : '63%',
            innerRadius: '40%',
            y: 62.9
        }]
    }];
    window['chart22'] = null;

    function initChart(){
        window['chart22'] = Highcharts.chart('chart-2-2', {
            chart      : {
                type           : 'solidgauge',
                backgroundColor: 'transparent',
                inverted       : true,
                height         : chart22Width,
                polar          : true,
                padding        : 0,
                margin         : 0,
                events         : {
                    load  : function () {
                        drawPlotLines(this);
                    },
                    redraw: function () {
                        drawPlotLines(this);
                    },
                },
            },
            credits    : false,
            title      : false,
            pane       : {
                startAngle: 360,
                endAngle  : 0,
                padding   : 0,
                width     : chart22Width,
                height    : chart22Width,
                center: ['50%', '50%'],
                size: "100%",
                background: {
                    backgroundColor: 'transparent',
                    borderWidth    : 0
                }

            },
            plotOptions:
                {
                    solidgauge: {
                        backgroundColor: 'transparent',
                        dataLabels     : {
                            enabled: false
                        },
                        enableMouseTracking: false,
                        stickyTracking : false,
                        states         : {
                            hover: {
                                enabled: false,
                            },
                        },
                        animation: {
                            duration: 1500,
                        }
                    },
                    series    : {
                        enableMouseTracking: false,
                        states: {
                            hover: {
                                enabled: false,
                            },
                        },
                    },
                },
            tooltip    : {
                enabled: false
            },
            yAxis      : {
                min          : 0,
                max          : 100,
                lineWidth    : 0,
                tickPositions: [],
            },
            series: series
        });
    }

    new ScrollMagic.Scene({
        offset: 0, // Number of pixels user can scroll before panel snaps into place
        triggerElement: '.section-2-2',
        // triggerHook: 0, // Trigger this scene when top of panel enters view
        triggerHook: 0.5
    })
    .on('enter', function(e) {
        let chart22Width = $('#chart-2-2').width();
        window['chart22'] = Highcharts.chart('chart-2-2', {
            chart      : {
                type           : 'solidgauge',
                backgroundColor: 'transparent',
                inverted       : true,
                height         : chart22Width,
                polar          : true,
                padding        : 0,
                margin         : 0,
                events         : {
                    load  : function () {
                        drawPlotLines(this);
                    },
                    redraw: function () {
                        drawPlotLines(this);
                    },
                },
            },
            credits    : false,
            title      : false,
            pane       : {
                startAngle: 360,
                endAngle  : 0,
                padding   : 0,
                width     : chart22Width,
                height    : chart22Width,
                center    : ['50%', '50%'],
                size      : "100%",
                background: {
                    backgroundColor: 'transparent',
                    borderWidth    : 0
                }

            },
            plotOptions:
                {
                    solidgauge: {
                        backgroundColor    : 'transparent',
                        dataLabels         : {
                            enabled: false
                        },
                        enableMouseTracking: false,
                        stickyTracking     : false,
                        states             : {
                            hover: {
                                enabled: false,
                            },
                        },
                        animation          : {
                            duration: 1500,
                        }
                    },
                    series    : {
                        enableMouseTracking: false,
                        states             : {
                            hover: {
                                enabled: false,
                            },
                        },
                    },
                },
            tooltip    : {
                enabled: false
            },
            yAxis      : {
                min          : 0,
                max          : 100,
                lineWidth    : 0,
                tickPositions: [],
            },
            series     : series
        });

        // initCounter('.section-2-2 .counter');
    })
    .addTo(require('../scrollInit'));
});
